<template>
  <div>
    <passiveinventory
    :passiveinventory="passiveInventory"
    :stocktypes="stockTypes"
    :key="key"
    :tableloading="tableLoading"
    @refresh="getPassiveInventory()"
    ></passiveinventory>
  </div>
</template>

<script>
import Api from "@/services/Api";
import PassiveInventory from "@/components/PassiveInventory.vue";

export default {
  components: {
    passiveinventory: PassiveInventory
  },
  data() {
    return {
        tableLoading: true,
        passiveInventory: [],
        stockTypes: [],
        key: 0
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
        this.getPassiveInventory();
        this.getStockWarehouses() 
    },
    getStockWarehouses(){
      Api()
      .get('/stockType')
      .then(response=>{
        this.stockTypes=response.data
      })
    },
    getPassiveInventory(){
        Api()
        .get("/passiveEquipment")
        .then(async response => {
          this.passiveInventory = response.data;
          this.tableLoading=false
          this.key+=1

        });
    },
  }
};
</script>

<style>
</style>